import styles from "./Bone.module.css";

/**
 * A placeholder in the real geometry of what is loading (UX ruling 5, F-5):
 * the register's rows, the record's head and columns — so nothing jumps when
 * the answer comes. It carries one slow glance of light across it (UD-4,
 * BW-11): waiting is the purpose that earns the motion, and it runs only for
 * as long as the bone is on screen — a loading state, nothing else. Under
 * reduced motion it is a still grey box (`Bone.module.css`). Hidden from
 * screen readers; the container says „lädt".
 */
export function Bone({ width = "100%", height }: { width?: string; height?: string }) {
  return <span className={styles.bone} style={{ inlineSize: width, blockSize: height }} aria-hidden="true" />;
}
